import { useTranslations } from 'next-intl';
import { Button, type ButtonProps } from '@/app/components/ui/button';
import { cn } from '@/app/utils';

interface FollowButtonProps extends ButtonProps {
  // 是否已关注
  isFollowing: boolean;
  // 是否互相关注
  isMutual?: boolean;
}

export const FollowButton = ({
  className,
  isFollowing,
  isMutual = false,
  variant = 'primary',
  ...props
}: FollowButtonProps) => {
  const t = useTranslations();

  return (
    <Button
      variant={isFollowing || isMutual ? 'ghost' : variant}
      className={cn(
        'h-8 flex-shrink-0 rounded-8 px-3 font-semibold text-sm',
        (isFollowing || isMutual) && 'bg-system-white10 hover:bg-system-white20 hover:text-system-white',
        variant === 'ghost' &&
          'h-8 rounded-8 bg-system-white10 px-3 font-semibold text-sm hover:bg-system-white20 hover:text-system-white sm:h-10 sm:flex-1',
        className,
      )}
      {...props}
    >
      {isMutual ? t('profile.mutualButton') : isFollowing ? t('profile.followingButton') : t('profile.followButton')}
    </Button>
  );
};
